import * as actions from '../actions/financialsTab';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

// HTTP driver for the Financials tab: GET api/Applications/{id}/Financials returns the DTO built by
// ApplicationService.GetApplicationFinancialsTask (LOI/case stage/damages + per-premium-type gross
// premium/IPT/commissions, plus a writeback block and currentLcSpend for percentage-premium policies).
//
// `applicationId` is set on the request object purely so it comes back on `response.request` -
// @cycle/http's driver echoes the exact request object it was given onto every response/error it
// produces, so any extra field we add here survives the round trip untouched. The reducer reads it
// off `action.payload.request.applicationId` to tell whether a response still belongs to the
// currently-selected policy, or is a stale reply for a policy the user has since navigated away from
// (see reducers/financialsTab.js for why that matters here).
export function requestFinancialsForPolicy(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_FINANCIALS_FOR_POLICY)
        .map(action => ({
            url: BASE_URL + 'api/Applications/' + action.payload + '/Financials',
            category: 'requestFinancialsForPolicy',
            method: 'GET',
            type: 'application/json',
            withCredentials: true,
            applicationId: action.payload
        }));

    let httpResponse$ = sources.HTTP
        .select('requestFinancialsForPolicy')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveFinancialsForPolicy(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorRequestFinancialsForPolicy(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestFinancialsForPolicy')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveFinancialsForPolicy(response));

    return {
        ACTION: httpResponse$
    };
}
